function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnderConstruction({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D2D3"
    },
    d: "M66.823,41.807h-28.19c-8.133,0-14.725,6.593-14.725,14.725v401.711c0,6.6,5.351,11.95,11.95,11.95 h33.74c6.6,0,11.95-5.351,11.95-11.95V56.532C81.548,48.399,74.955,41.807,66.823,41.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D2D3"
    },
    d: "M445.177,41.807h28.19c8.133,0,14.725,6.593,14.725,14.725v401.711c0,6.6-5.351,11.95-11.95,11.95 h-33.74c-6.6,0-11.95-5.351-11.95-11.95V56.532C430.452,48.399,437.045,41.807,445.177,41.807z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#465059"
    },
    points: "74.425,78.967 25.806,101.334 0,153.394 0,233.703 101.506,171.355 154.735,78.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#465059"
    },
    points: "228.749,78.967 101.506,171.355 43.974,263.742 124.284,263.742 240.516,188.731 309.058,78.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#465059"
    },
    points: "383.071,78.967 240.516,188.731 198.296,263.742 278.606,263.742 395.303,184.671 463.381,78.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#465059"
    },
    points: "383.071,201.118 352.62,263.742 432.929,263.742 490.323,233.703 512,184.671 512,104.361 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M512,184.671v55.164c0,13.203-10.705,23.907-23.907,23.907h-55.164L512,184.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M512,102.875v1.487l-159.38,159.38h-74.013L463.381,78.967h24.712 C501.295,78.967,512,89.672,512,102.875z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD38"
    },
    points: "383.071,78.967 198.296,263.742 124.284,263.742 309.058,78.967  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M228.749,78.967L43.974,263.742H23.907C10.705,263.742,0,253.037,0,239.834v-6.132L154.735,78.967 H228.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M74.425,78.967L0,153.394v-50.519c0-13.203,10.705-23.907,23.907-23.907H74.425z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.911,
    y: 263.737,
    style: {
      fill: "#BAB8B9"
    },
    width: 57.642,
    height: 31.101
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.451,
    y: 263.737,
    style: {
      fill: "#BAB8B9"
    },
    width: 57.642,
    height: 31.101
  }));
}

export default "data:image/svg+xml;base64,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";
export { SvgUnderConstruction as ReactComponent };